import { useRef, useState } from "react";
import api, { API, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Camera, X, Loader2, ImagePlus } from "lucide-react";

const MAX = 5;

export const photoUrl = (id) => `${API}/files/${id}`;

export const PhotoUpload = ({ photos, onChange }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    if (photos.length + files.length > MAX) { toast.error(`Maximal ${MAX} Fotos`); return; }
    const tooBig = files.find((f) => f.size > 8 * 1024 * 1024);
    if (tooBig) { toast.error(`${tooBig.name} ist größer als 8 MB`); return; }
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    setBusy(true);
    try {
      const { data } = await api.post("/uploads/photos", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange([...photos, ...data.files.map((f) => f.id)]);
      toast.success(`${data.files.length} Foto(s) hochgeladen`);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="photo-upload">
      <label className="eb-label flex items-center gap-2"><Camera className="w-3.5 h-3.5" /> Fotos vom Transportgut (optional, max. {MAX} à 8 MB)</label>
      <div className="flex flex-wrap gap-3 mt-3">
        {photos.map((id) => (
          <div key={id} className="relative w-24 h-24 rounded-lg overflow-hidden border border-slate-800 group" data-testid={`photo-thumb-${id}`}>
            <img src={photoUrl(id)} alt="Transportgut" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange(photos.filter((p) => p !== id))} data-testid={`photo-remove-${id}`}
              className="absolute top-1 right-1 bg-black/70 rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <X className="w-3 h-3 text-white" />
            </button>
          </div>
        ))}
        {photos.length < MAX && (
          <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid="photo-add-btn"
            className="w-24 h-24 rounded-lg border border-dashed border-slate-700 hover:border-[#FF5A1F] flex flex-col items-center justify-center gap-1 text-slate-500 hover:text-[#FF5A1F] transition-colors text-xs">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <ImagePlus className="w-5 h-5" />}
            {busy ? "Lädt…" : "Foto"}
          </button>
        )}
      </div>
      <input ref={ref} type="file" accept="image/*" multiple className="hidden" onChange={pick} data-testid="photo-file-input" />
    </div>
  );
};
